createSafeModule('app.formalizacao', [
    'ui.router',
    'ngResource',
    'lazyLoad'
]);